/**
 * Docs from
 * https://primeng.org/tabs
 */
export const tabs = {
  tabpanel: {
    padding: '0.875rem 0 1.125rem 0',
  },
};
